// ----------------------------------------------------------------------------
// Snippet: Product Zoom
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_product-zoom.scss';

// -------------------------------------
// Variables
// -------------------------------------
var MODAL_SELECTOR = '.modal--product-zoom';
var MODAL_CONTAINER_SELECTOR = '.modal__content_media_container';
var HEADER_SELECTOR = '.shopify-section--header';
var SWIPER_WRAPPER_SELECTOR = '.product__feature-image.carousel--featured-product.swiper .swiper-wrapper';
var ZOOM_TRIGGER_SELECTORS = ['.media-zoom-button', '.product-single__media-wrapper picture img'];
var MODAL_CLOSE_SELECTORS = ['.close-zoom', '.icon-close-zoom'];
function initProductZoomModal() {
  var modal = document.querySelector(MODAL_SELECTOR);
  var modalContainer = document.querySelector(MODAL_CONTAINER_SELECTOR);
  var header = document.querySelector(HEADER_SELECTOR);
  if (!modal || !modalContainer) return;
  var isDesktop = () => window.innerWidth >= 1024;
  var populateModalContent = () => {
    var swiperWrapper = document.querySelector(SWIPER_WRAPPER_SELECTOR);
    if (!swiperWrapper) return;
    var slides = Array.from(swiperWrapper.children);
    var filteredSlidesHTML = slides.filter(slide => !slide.querySelector('.product-single__media--video') && !slide.querySelector('.video-block')).map(slide => slide.outerHTML).join('');
    modalContainer.innerHTML = filteredSlidesHTML;
  };
  var openModal = target => {
    if (!isDesktop()) return;
    var mediaWrapper = target.closest('.product-single__media-wrapper');
    if (!mediaWrapper) return;
    var imageID = mediaWrapper.id;
    modal.classList.add('modal--open');
    document.body.classList.add('noscroll');
    header === null || header === void 0 || header.classList.add('sendback');
    var scrollTarget = modalContainer.querySelector("#".concat(imageID));
    scrollTarget === null || scrollTarget === void 0 || scrollTarget.scrollIntoView({
      block: 'start'
    });
    window.dispatchEvent(new CustomEvent('open.modal', {
      detail: modal
    }));
  };
  var closeModal = () => {
    if (!isDesktop()) return;
    modal.classList.remove('modal--open');
    document.body.classList.remove('noscroll');
    header === null || header === void 0 || header.classList.remove('sendback');
    window.dispatchEvent(new CustomEvent('close.modal', {
      detail: modal
    }));
  };
  var addEventListeners = () => {
    ZOOM_TRIGGER_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.addEventListener('click', e => openModal(e.target)));
    });
    MODAL_CLOSE_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.addEventListener('click', closeModal));
    });
  };
  populateModalContent();
  addEventListeners();
}

// Init on DOM load
document.addEventListener('DOMContentLoaded', () => {
  initProductZoomModal();
});